import world from './world/store';
import zone from './zone/store';

export default {
  namespaced: true,
  modules: { world, zone },
};
